import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Subject, Observable, takeUntil } from 'rxjs';
import { SnoozeIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/snooze-incident-dialog/snooze-incident-dialog.component';
import { VerifyIncidentDialogComponent } from 'src/app/common/modules/dialog-pop-ups/components/verify-incident-dialog/verify-incident-dialog.component';
import { ScreenType } from 'src/app/enums/ScreenType';
import { IIncidents } from 'src/app/models/incident';
import { ComplaintsTickets } from 'src/app/models/tickets';
import { EncryptionService } from 'src/app/services/Encryption/encryption.service';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';
import { IAnalyticsState } from 'src/app/state-management/states/aumye-analytics.state';
import { IDashboardState } from 'src/app/state-management/states/aumye-dashboard.state';
import { IAumyeState } from 'src/app/state-management/states/aumye.state';

@Component({
  selector: 'app-claims-container',
  templateUrl: './claims-container.component.html',
  styleUrl: './claims-container.component.scss',
})
export class ClaimsContainerComponent {
  @Input() set isIncidentDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }
  @Output() verifyIncident = new EventEmitter<any>();
  @Output() getRangeServiceData = new EventEmitter<any>();
  @Output() showServiceDetails = new EventEmitter<any>();
  @Output() getRequestData = new EventEmitter<any>();
  // @Output() verifyServiceIncident = new EventEmitter<any>();
  @Output() snoozeIncident = new EventEmitter<any>();
  currentDate: Date = new Date();
  destroyed$: Subject<any> = new Subject<any>();
  analyticsState$: Observable<IAnalyticsState>;
  analyticsState: IAnalyticsState;
  dashboardDataState$: Observable<IDashboardState>;
  dashboardData: IDashboardState;
  isComplaints = false;
  isClaims = true;
  isRequests = false;
  claimStatusData: any;
  @ViewChild('RefreshingRequest', { static: true })
  refreshingRequest: TemplateRef<any>;
  claimList: ComplaintsTickets[] = [];
  readonly range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });
  constructor(
    private screen: AumyeResponsiveScreenService,
    private store: Store<IAumyeState>,
    private dialog: MatDialog,
    private encryptionService: EncryptionService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });

    this.dashboardDataState$ = this.store.select('aumyeDashboardState');
    this.dashboardDataState$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((data) => {
        this.dashboardData = data;
        this.claimList = data.claimTickets;
        let tempVal = data.claimTickets;
        this.complaintList = tempVal;
        this.claimStatusData = {
          openCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 0
          ).length,
          closedCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 1
          ).length,
          inProgressCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 4
          ).length,
          onHoldCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 5
          ).length,
          approvedCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 6
          ).length,
          rejectedCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 7
          ).length,
          verifiedCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 2
          ).length,
          snoozedCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 3
          ).length,
          completeCount: this.complaintList.filter(
            (x) => x.complainIncidentDetails.incidentStatus == 8
          ).length,
        };
        this.tempComplaints = tempVal;
        this.totalClaim = this.claimList.length;
        let todayClaimList = this.claimList.filter((x) => {
          const date1 = new Date(x.complainAddDate + 'Z');
          const date2 = new Date();
          const sameDate =
            date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
          return sameDate;
        });
        this.todayClaim = todayClaimList.filter(
          (x) =>
            x.complainSubject === 'Claim' ||
            x.complainSubject === 'Unsettled Claim'
        ).length;
        this.todayOpenClaim = todayClaimList.filter(
          (x) =>
            (x.complainSubject === 'Claim' ||
              x.complainSubject === 'Unsettled Claim') &&
            x.complainStatus === '0'
        ).length;
        this.todayClosedClaim = todayClaimList.filter(
          (x) =>
            (x.complainSubject === 'Claim' ||
              x.complainSubject === 'Unsettled Claim') &&
            x.complainStatus === '1'
        ).length;

        this.totalClaimAmount = this.claimList.reduce(
          (total, complaint) =>
            total +
            Number(
              complaint.complainDescription.match(/Claim Amount: (\d+)/)?.[1] ||
                0
            ),
          0
        );
        this.totalOpenClaim = this.complaintList.filter(
          (x) =>
            (x.complainSubject === 'Claim' ||
              x.complainSubject === 'Unsettled Claim') &&
            x.complainIncidentDetails.incidentStatus === 0
        ).length;
        this.totalOpenClaimAmount = this.complaintList
          .filter(
            (x) =>
              (x.complainSubject === 'Claim' ||
                x.complainSubject === 'Unsettled Claim') &&
              x.complainIncidentDetails.incidentStatus === 0
          )
          .reduce(
            (total, complaint) =>
              total +
              Number(
                complaint.complainDescription.match(
                  /Claim Amount: (\d+)/
                )?.[1] || 0
              ),
            0
          );
        this.totalClosedClaim = this.complaintList.filter(
          (x) =>
            (x.complainSubject === 'Claim' ||
              x.complainSubject === 'Unsettled Claim') &&
            x.complainIncidentDetails.incidentStatus === 1
        ).length;
        this.totalClosedClaimAmount = this.complaintList
          .filter(
            (x) =>
              (x.complainSubject === 'Claim' ||
                x.complainSubject === 'Unsettled Claim') &&
              x.complainIncidentDetails.incidentStatus === 1
          )
          .reduce(
            (total, complaint) =>
              total +
              Number(
                complaint.complainDescription.match(
                  /Claim Amount: (\d+)/
                )?.[1] || 0
              ),
            0
          );
        this.onUpdateExistingDataTable();
      });
  }
  screenSize: ScreenType;
  complaintList: ComplaintsTickets[] = [];
  tempComplaints: ComplaintsTickets[] = [];
  ScreenType = ScreenType;
  totalOpenClaim: number = 0;
  totalClosedClaim: number = 0;
  totalClaim: number = 0;
  todayOpenClaim: number = 0;
  todayClosedClaim: number = 0;
  todayClaim: number = 0;
  totalOpenClaimAmount: number = 0;
  totalClosedClaimAmount: number = 0;
  totalClaimAmount: number = 0;
  isShowDetails = false;
  expandedDetail: string = null;
  displayedColumns = [
    'name',
    'date',
    'time',
    'asset',
    'assignee',
    'action',
    'Details',
  ];
  // Enhanced Filter Properties
  selectedPrimaryFilter = 'all';
  selectedMyIssuesType = 'all';
  selectedAssignedUsers: string[] = [];
  selectedReporters: string[] = [];

  // Available options for dropdowns
  availableAssignedUsers: { userId: string; userName: string }[] = [];
  availableReporters: string[] = [];
  /**
   * Initialize filter options based on available data
   */
  initializeFilterOptions(): void {
    if (this.tempComplaints && this.tempComplaints.length > 0) {
      // Get unique assigned users (handling multiple assignees)
      const allAssignedUsers: { userId: string; userName: string }[] = [];

      this.tempComplaints.forEach((complaint) => {
        try {
          // Parse the assignedUsers JSON string
          const assigneeList: any[] = JSON.parse(
            complaint.complainIncidentDetails.assignedUsers || '[]'
          );
          if (assigneeList.length > 0) {
            assigneeList.forEach((x) => {
              if (x.UserId && x.UserName && x.UserName.trim() !== '') {
                allAssignedUsers.push({
                  userId: x.UserId,
                  userName: x.UserName,
                });
              }
            });
          }
          // Fallback to assignedTo if assignedUsers is empty
          else if (
            complaint.complainIncidentDetails.assignedTo &&
            complaint.complainIncidentDetails.assignedTo.trim() !== ''
          ) {
            allAssignedUsers.push({
              userId:
                complaint.complainIncidentDetails.assignedToUserId ||
                complaint.complainIncidentDetails.assignedTo,
              userName: complaint.complainIncidentDetails.assignedTo,
            });
          }
        } catch (error) {
          // If JSON parsing fails, fallback to assignedTo
          if (
            complaint.complainIncidentDetails.assignedTo &&
            complaint.complainIncidentDetails.assignedTo.trim() !== ''
          ) {
            allAssignedUsers.push({
              userId:
                complaint.complainIncidentDetails.assignedToUserId ||
                complaint.complainIncidentDetails.assignedTo,
              userName: complaint.complainIncidentDetails.assignedTo,
            });
          }
        }
      });

      // Remove duplicates based on userId and sort by userName
      const uniqueUsers = allAssignedUsers
        .filter(
          (user, index, self) =>
            index === self.findIndex((u) => u.userId === user.userId)
        )
        .sort((a, b) => a.userName.localeCompare(b.userName));

      this.availableAssignedUsers = uniqueUsers;

      // Get unique reporters
      this.availableReporters = [
        ...new Set(
          this.tempComplaints
            .map(
              (complaint) => complaint.complainIncidentDetails.eventCreatedBy
            )
            .filter((reporter) => reporter && reporter.trim() !== '')
        ),
      ].sort();
    }
  }
  /**
   * Handle primary filter change
   */
  onPrimaryFilterChange(event: any): void {
    this.selectedPrimaryFilter = event.value;

    // Reset sub-filters when primary filter changes
    this.selectedMyIssuesType = 'all';
    this.selectedAssignedUsers = [];
    this.selectedReporters = [];

    this.applyAllFilters();
  }

  /**
   * Handle my issues type change
   */
  onMyIssuesTypeChange(event: any): void {
    this.selectedMyIssuesType = event.value;
    this.applyAllFilters();
  }

  /**
   * Handle assigned users change
   */
  onAssignedUsersChange(event: any): void {
    this.selectedAssignedUsers = event.value;
    this.applyAllFilters();
  }

  /**
   * Handle reporters change
   */
  onReportersChange(event: any): void {
    this.selectedReporters = event.value;
    this.applyAllFilters();
  }

  /**
   * Apply all filters based on current selections
   */
  applyAllFilters(): void {
    let filteredData = [...this.tempComplaints];

    // Apply primary filter
    switch (this.selectedPrimaryFilter) {
      case 'my-issues':
        filteredData = this.applyMyIssuesFilter(filteredData);
        break;
      case 'assigned-to':
        filteredData = this.applyAssignedToFilter(filteredData);
        break;
      case 'reported-by':
        filteredData = this.applyReportedByFilter(filteredData);
        break;
      case 'all':
      default:
        // No additional filtering needed for 'all'
        break;
    }

    // Apply status filter
    const selectedStatus = +this.selectedStatus;
    if (selectedStatus !== -1) {
      filteredData = filteredData.filter(
        (complaint: ComplaintsTickets) =>
          complaint.complainIncidentDetails.incidentStatus === selectedStatus
      );
    }

    this.complaintList = filteredData;
  }

  /**
   * Apply my issues filter
   */
  private applyMyIssuesFilter(data: ComplaintsTickets[]): ComplaintsTickets[] {
    const currentUser = this.encryptionService.getCurrentUser();
    const currentUserId = currentUser.userID;
    const currentUserName = currentUser.fullName || currentUser.firstName;

    switch (this.selectedMyIssuesType) {
      case 'reported':
        return data.filter(
          (complaint) =>
            complaint.complainIncidentDetails.eventCreatedByUserID ===
              currentUserId ||
            complaint.complainIncidentDetails.eventCreatedBy === currentUserName
        );
      case 'assigned':
        return data.filter((complaint) => {
          // Check if user is in the assignedUsers list
          try {
            const assigneeList: any[] = JSON.parse(
              complaint.complainIncidentDetails.assignedUsers || '[]'
            );
            const isAssigned = assigneeList.some(
              (x) => x.UserId === currentUserId
            );

            // Also check the assignedToUserId field as fallback
            const isAssignedTo =
              complaint.complainIncidentDetails.assignedToUserId ===
                currentUserId ||
              complaint.complainIncidentDetails.assignedTo === currentUserName;

            return isAssigned || isAssignedTo;
          } catch (error) {
            // Fallback to assignedTo if JSON parsing fails
            return (
              complaint.complainIncidentDetails.assignedToUserId ===
                currentUserId ||
              complaint.complainIncidentDetails.assignedTo === currentUserName
            );
          }
        });
      case 'all':
      default:
        return data.filter((complaint) => {
          const isReporter =
            complaint.complainIncidentDetails.eventCreatedByUserID ===
              currentUserId ||
            complaint.complainIncidentDetails.eventCreatedBy ===
              currentUserName;

          // Check if user is assigned
          try {
            const assigneeList: any[] = JSON.parse(
              complaint.complainIncidentDetails.assignedUsers || '[]'
            );
            const isAssigned = assigneeList.some(
              (x) => x.UserId === currentUserId
            );
            const isAssignedTo =
              complaint.complainIncidentDetails.assignedToUserId ===
                currentUserId ||
              complaint.complainIncidentDetails.assignedTo === currentUserName;

            return isReporter || isAssigned || isAssignedTo;
          } catch (error) {
            return (
              isReporter ||
              complaint.complainIncidentDetails.assignedToUserId ===
                currentUserId ||
              complaint.complainIncidentDetails.assignedTo === currentUserName
            );
          }
        });
    }
  }

  /**
   * Apply assigned to filter
   */
  private applyAssignedToFilter(
    data: ComplaintsTickets[]
  ): ComplaintsTickets[] {
    if (this.selectedAssignedUsers.length === 0) {
      return data;
    }

    return data.filter((complaint) => {
      try {
        // Parse the assignedUsers JSON string
        const assigneeList: any[] = JSON.parse(
          complaint.complainIncidentDetails.assignedUsers || '[]'
        );

        // Check if any of the selected user IDs is in the assignee list
        const hasSelectedAssignee = assigneeList.some((assignee) =>
          this.selectedAssignedUsers.includes(assignee.UserId)
        );

        // Also check the assignedToUserId field as fallback
        const isAssignedTo = this.selectedAssignedUsers.includes(
          complaint.complainIncidentDetails.assignedToUserId
        );

        return hasSelectedAssignee || isAssignedTo;
      } catch (error) {
        // Fallback to assignedToUserId if JSON parsing fails
        return this.selectedAssignedUsers.includes(
          complaint.complainIncidentDetails.assignedToUserId
        );
      }
    });
  }

  /**
   * Apply reported by filter
   */
  private applyReportedByFilter(
    data: ComplaintsTickets[]
  ): ComplaintsTickets[] {
    if (this.selectedReporters.length === 0) {
      return data;
    }

    return data.filter((complaint) =>
      this.selectedReporters.includes(
        complaint.complainIncidentDetails.eventCreatedBy
      )
    );
  }

  /**
   * Clear all filters and reset to default state
   */
  clearAllFilters(): void {
    this.selectedPrimaryFilter = 'all';
    this.selectedMyIssuesType = 'all';
    this.selectedAssignedUsers = [];
    this.selectedReporters = [];
    this.selectedStatus = '-1';
    this.enteredValue = '';

    // Clear search input
    const searchInput = document.querySelector(
      'input[matInput]'
    ) as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }

    // Reset data
    this.complaintList = this.tempComplaints;
  }
  onShowDetails(val: any) {
    this.isShowDetails = true;
    this.expandedDetail = val.complainId;
    this.showServiceDetails.emit(val);
  }
  onSnoozeIncident(val: IIncidents) {
    const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
      disableClose: true,
      data: val,
    });
    let decryptedUserData = this.encryptionService.decrypt(
      localStorage.getItem('UserDetails')
    );
    dialogRef.afterClosed().subscribe((result: any) => {
      let data = {
        isSnooze: true,
        durationType: result.durationType,
        durationSize: result.durationSize,
        incidentId: val.incidentId,
        orgId: val.orgId,
        incidenType: val.incidentType,
        incidentName: val.incidentName,
        assignedBy:
          decryptedUserData.FirstName + ' ' + decryptedUserData.LastName,
        assignedById: decryptedUserData.UserID,
        createBy: val.eventCreatedBy,
        createById: val.eventCreatedByUserID,
        assignTo: val.assignedTo,
        assignedToUserId: val.assignedToUserId,
        evidence: val.eventEvidence,
      };
      if (result) {
        this.snoozeIncident.emit(data);
      }
    });
  }
  onClickStatus(val: any) {
    const dialogRef = this.dialog.open(VerifyIncidentDialogComponent, {
      disableClose: true,
      data: val.complainIncidentDetails,
    });
    dialogRef.afterClosed().subscribe((result: string) => {
      let data: any = {
        status:
          result == 'Open'
            ? '0'
            : result == 'Close'
            ? '1'
            : result == 'Verified'
            ? '2'
            : result == 'Snooze'
            ? '3'
            : result == 'In-Progress'
            ? '4'
            : result == 'On-Hold'
            ? '5'
            : result == 'Approved'
            ? '6'
            : result == 'Rejected'
            ? '7'
            : result == 'Completed'
            ? '8'
            : '',
        incidentId: val.complainId,
      };
      if (data.status == '3') {
        const dialogRef = this.dialog.open(SnoozeIncidentDialogComponent, {
          disableClose: true,
          data: val.complainIncidentDetails,
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          let data = {
            isSnooze: true,
            durationType: result.durationType,
            durationSize: result.durationSize,
            incidentId: val.complainIncidentDetails.incidentId,
            incidentStatusTimeline:
              val.complainIncidentDetails.incidentStatusTimeline,
            status: '3',
            previousStatus: val.complainIncidentDetails.incidentStatus,
          };
          if (result) {
            this.verifyIncident.emit(data);
          }
        });
      } else {
        if (result) {
          const previousStatus = this.dashboardData.claimTickets.find(
            (x) => x.complainId == val.complainId.toLowerCase()
          ).complainIncidentDetails;
          data['incidentStatusTimeline'] =
            previousStatus.incidentStatusTimeline;
          data['previousStatus'] = previousStatus.incidentStatus;
          this.verifyIncident.emit(data);
        }
      }
    });
  }
  isClickedSubmit = false;
  onClickGetRangeData() {
    this.dialog.open(this.refreshingRequest, {
      disableClose: true,
    });
    const data = {
      startDate: this.range.controls.start.value,
      endDate: this.range.controls.end.value,
      type: this.isClaims
        ? 'CLAIM'
        : this.isComplaints
        ? 'COMPLAIN'
        : 'REQUESTS',
    };
    this.getRangeServiceData.emit(data);
    this.isClickedSubmit = true;
  }
  onGetResetData() {
    this.range.reset();
    this.getRequestData.emit();
  }
  enteredValue = '';
  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.enteredValue = filterValue;
    // Filter the temp array
    this.complaintList = this.tempComplaints.filter((request) => {
      return request.complainId.trim().toLowerCase().includes(filterValue);
    });
  }
  applyFilterCustom(event: any) {
    const filterValue = (event.target as HTMLInputElement).value
      .trim()
      .toLowerCase();
    this.enteredValue = filterValue;

    // Start with the currently filtered data based on other filters
    let baseData = [...this.tempComplaints];

    // Apply primary filter first
    switch (this.selectedPrimaryFilter) {
      case 'my-issues':
        baseData = this.applyMyIssuesFilter(baseData);
        break;
      case 'assigned-to':
        baseData = this.applyAssignedToFilter(baseData);
        break;
      case 'reported-by':
        baseData = this.applyReportedByFilter(baseData);
        break;
    }

    // Apply status filter
    const selectedStatus = +this.selectedStatus;
    if (selectedStatus !== -1) {
      baseData = baseData.filter(
        (complaint: ComplaintsTickets) =>
          complaint.complainIncidentDetails.incidentStatus === selectedStatus
      );
    }

    // Apply text search filter
    this.complaintList = baseData.filter((complain: ComplaintsTickets) => {
      const incident = complain.complainIncidentDetails;

      const incidentNameMatch = (incident.incidentName || '')
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const incidentDescriptionMatch = (incident.incidentDescription || '')
        .trim()
        .toLowerCase()
        .includes(filterValue);

      const incidentIdMatch = (incident.incidentId || '')
        .toString()
        .toLowerCase()
        .includes(filterValue);

      // Check multiple assignees
      let assigneeMatch = false;
      try {
        const assigneeList: any[] = JSON.parse(incident.assignedUsers || '[]');
        assigneeMatch = assigneeList.some((assignee) =>
          (assignee.UserName || '').toLowerCase().includes(filterValue)
        );
      } catch (error) {
        // Fallback to assignedTo
        assigneeMatch = (incident.assignedTo || '')
          .toString()
          .toLowerCase()
          .includes(filterValue);
      }

      // Also check the assignedTo field
      const assignedToMatch = (incident.assignedTo || '')
        .toString()
        .toLowerCase()
        .includes(filterValue);

      const reporterMatch = (incident.eventCreatedBy || '')
        .toString()
        .toLowerCase()
        .includes(filterValue);

      return (
        incidentIdMatch ||
        incidentNameMatch ||
        reporterMatch ||
        assigneeMatch ||
        assignedToMatch ||
        incidentDescriptionMatch
      );
    });
  }
  selectedStatus = '-1';

  onChangeDataTable(event: any) {
    this.selectedStatus = event.value;
    this.applyAllFilters();
  }
  onUpdateExistingDataTable() {
    this.initializeFilterOptions();
    this.applyAllFilters();
  }
  getFormatedDate(val: any) {
    // let localDate = new Date(val);
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
}
